<style lang="scss">
</style>

<template>
    <div class="search-wrap">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button  v-for="(item,index) in btnsearch" size="large" :key="index" :type="formData.EQ_disposition===item.value?'primary':'default'" @click="handleBtn('EQ_disposition',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-right">
                <Form :label-width="90" inline>
                     <FormItem label='Seller SKU'>
                         <Input clearable v-model="formData.EQ_sellerSku"/>
                    </FormItem>
                    <FormItem label='ERPSKU'>
                        <Input clearable v-model="formData.EQ_erpSku"/>
                    </FormItem>
                    <FormItem label='发运数量'>
                        <Input clearable v-model="formData.EQ_shippingNum" :min='0'/>
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update(false)" icon="ios-search">搜索</Button>
                        <Button @click="update(true)" icon='md-refresh'>重置</Button>
                        <Button type="text" @click="isOpen=!isOpen">更多搜索<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both'>
            <Form class="search-other" :label-width="80" inline v-show="isOpen">
                <FormItem label='接收数量' :min='0'>
                    <Input clearable v-model="formData.EQ_inboundAmount"/>
                </FormItem>
                <FormItem label='商品状态'>
                    <Select v-model="formData.EQ_disposition">
                       <Option value="sellable ">sellable</Option>
                       <Option value="unsellable ">unsellable</Option>
                    </Select>
                </FormItem>
                <FormItem label='承运商'>
                    <Input clearable v-model="formData.EQ_carrier"/>
                </FormItem>
                <FormItem label='tracking'>
                     <Input clearable v-model="formData.EQ_tracking"/>
                </FormItem>
                <FormItem label='航运状态'>
                     <Input clearable v-model="formData.EQ_shippingType"/>
                </FormItem>
                <FormItem label='来源'>
                     <Select clearable v-model="formData.EQ_source"  >
                        <Option value="0">自动更新</Option>
                        <Option value="1">手动更新</Option>
                    </Select>
                </FormItem>
                <FormItem label='发运时间'>
                    <DatePicker type="date" v-model="formData.GE_deliveryAt"></DatePicker>
                </FormItem>
                 <FormItem label='发运时间'>
                    <DatePicker type="date" v-model="formData.LE_deliveryAt"></DatePicker>
                </FormItem>
            </Form>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
// import { HttpGroupRuleItem } from '@/service/allotment/transfer'

export default {
    data() {
        return {
            isOpen: false,
            btnsearch: [{
                value: 'sellable',
                label: "sellable"
            }, {
                value: 'unsellable',
                label: "unsellable"
            }, {
                value: null,
                label: '所有'
            }],
            formData: {},
        };
    },
    created() {
        this.formData = { ...this.initForm };
    },
    mounted() {
        this.update();
    },
    computed: {
        // ...mapState('boss',['products', 'warehouses']),
        initForm() {
            return {
                EQ_sellerSku: '',
                EQ_erpSku: '',
                EQ_shippingNum: '',
                EQ_inboundAmount: '',
                EQ_disposition: null,
                EQ_carrier: '',
                EQ_tracking: '',
                EQ_shippingType: '',
                EQ_source: '',
                LE_deliveryAt: '',
                GE_deliveryAt: '',
            }
        }
    },
    methods: {

        handleModal(type, id) {
            this.$parent.handleOperate(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update(reset = false) {
            if (reset) this.formData = { ...this.initForm };

            let search = { ...this.formData, LE_deliveryAt: this.handleDateFormat(this.formData.LE_deliveryAt, 'yyyy-mm-dd'), GE_deliveryAt: this.handleDateFormat(this.formData.GE_deliveryAt, 'yyyy-mm-dd') };
            this.$emit('on-update', { search });
        },
    },
};
</script>
